import { useEffect, useState } from 'react'

export function useMediaQuery() {
  const [device, setDevice] = useState<'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | null>(null)
  const [screenWidth, setScreenWidth] = useState<number>(0)
  const [screenHeight, setScreenHeight] = useState<number>(0)

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth
      const height = window.innerHeight

      setScreenWidth(width)
      setScreenHeight(height)

      if (window.matchMedia('(max-width: 639px)').matches) {
        setDevice('xs')
      } else if (window.matchMedia('(min-width: 640px) and (max-width: 767px)').matches) {
        setDevice('sm')
      } else if (window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches) {
        setDevice('md')
      } else if (window.matchMedia('(min-width: 1024px) and (max-width: 1279px)').matches) {
        setDevice('lg')
      } else if (window.matchMedia('(min-width: 1280px) and (max-width: 1535px)').matches) {
        setDevice('xl')
      } else if (window.matchMedia('(min-width: 1536px)').matches) {
        setDevice('2xl')
      }
    }

    checkDevice()

    window.addEventListener('resize', checkDevice)

    return () => {
      window.removeEventListener('resize', checkDevice)
    }
  }, [])

  return {
    isMobile: device === 'xs' || device === 'sm' || device === 'md',
    device,
    screenWidth,
    screenHeight,
  }
}
